export   function getLocaltype(){
    let loginType=1
    const device = navigator.userAgent
if (device.indexOf('iPad') > -1) {
// alert('ipad')
loginType=1
} else if (device.indexOf('Android') > -1 || device.indexOf('ios') > -1) {
// alert('手机')
loginType=2
} else {
// 电脑
loginType=1
// alert('电脑')
}
if(isMobile()){
// alert("移动")
loginType=2
}else{
// alert("电脑")
loginType=1
}
return loginType
}

function  isMobile () {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag
  }


// WEBPACK FOOTER //
// ./src/components/mainConfig/thu.js